const chargesLang = {
  menuTitle: 'Charges',
  clone: 'Cloner',
  charges: {
    menu: 'Charges',
    label: 'Charge',
    reference: 'Charge n°%{reference}',
    listTitle: 'Liste des charges',
    addTitle: 'Création d\'une charge',
    editTitle: 'Modification d\'une charge',
    addLabel: 'Créer une charge',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette charge ?',
    typeCharge: 'Charge',
    typeCredit: 'Avoir',
    statusMarkAs: 'Marquer comme',
    statusEdit: 'Êtes-vous sûr de vouloir modifier le statut de la charge à',
    statusDraft: 'Brouillon',
    statusPaymentWait: 'En attente de paiement',
    statusToPaid: 'À payer',
    statusPartiallyPaid: 'Payée partiellement',
    statusPaid: 'Payée',
    list: {
      type: 'Type',
      reference: 'Référence',
      date: 'Date',
      paymentDate: 'Limite de paiement',
      title: 'Titre',
      customer: 'Fournisseur',
      contact: 'Contact',
      invoiceReference: 'N°facture fournisseur',
      currency: 'Devise',
      exchangeRate: 'Taux de change',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      alreadyPaid: 'Déjà payé',
      stayToPay: 'Reste à payer',
      status: 'Statut',
      paymentTerm: 'Condition de paiement'
    },
    filters: {
      type: 'Type',
      reference: 'Référence',
      provider: 'Fournisseur(s)',
      contact: 'Contact(s)',
      date: 'Date',
      paymentDate: 'Limite de paiement',
      created: 'Date de création',
      invoiceReference: 'N°facture fournisseur',
      status: 'Statut',
      category: 'Catégorie de charge'
    },
    form: {
      type: 'Type de charge',
      title: 'Titre',
      date: 'Date',
      paymentDate: 'Limite de paiement',
      currency: 'Devise',
      provider: 'Fournisseur',
      providerInvoice: 'N° facture fournisseur',
      contentsTitle: 'Contenu de la charge',
      emptyLine: 'Ligne vide',
      designation: 'Désignation',
      unitPrice: 'Prix U. HT',
      vatRate: 'Taux TVA',
      quantity: 'Quantité',
      totalHT: 'Total HT',
      totalTVA: 'Total TVA',
      totalTTC: 'Total TTC',
      noLine: 'Aucune ligne',
      createBtn: 'Créer la charge',
      editBtn: 'Modifier la charge',
      custom: 'Personnalisé',
      currencyRate: 'Taux de change',
      category: 'Catégorie de charge :',
      paymentTerm: 'Condition de paiement'
    },
    item: {
      title: 'Charge n°%{reference}',
      titleCredit: 'Avoir n°%{reference}',
      toPaidStatus: 'À payer',
      type: 'Type',
      file: 'Justificatif',
      sendFile: 'Ajouter le justificatif',
      fileDelete: 'Êtes-vous sûr de vouloir supprimer le justificatif ?',
      date: 'Date',
      paymentDate: 'Limite de paiement',
      provider: 'Fournisseur',
      contact: 'Contact',
      providerInvoice: 'N°facture fournisseur',
      totalHT: 'Total HT',
      totalTVA: 'Total TVA',
      totalTTC: 'Total TTC',
      chargeAlreadyPaid: 'Cette charge est déjà payée',
      alreadyPaid: 'Déjà payé',
      toPaid: 'Reste à payer',
      content: 'Contenu',
      elements: 'Éléments',
      payments: 'Paiements',
      cantEdit: 'Vous ne pouvez pas modifier la charge car elle fait partie d\'une période clôturée',
      cantDelete: 'Vous ne pouvez pas supprimer la charge car elle fait partie d\'une période clôturée',
      commandReference: 'Commande n°%{reference}',
      deletedProvider: 'Fournisseur supprimé',
      linkedDocuments: 'Document liés'
    }
  },
  params: {
    menu: 'Paramètres',
    pageTitle: 'Paramètres des charges',
    defaultStatus: 'Statut par défaut des charges',
    referenceTitle: 'Numérotation des charges'
  },
  payments: {
    menu: 'Paiements',
    listTitle: 'Liste des paiements',
    statusToUse: 'À utiliser',
    statusPartiallyUsed: 'Utilisé partiellement',
    statusUsed: 'Utilisé',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce paiement ?',
    list: {
      type: 'Type',
      date: 'Date',
      reference: 'Référence',
      provider: 'Fournisseur',
      amount: 'Montant',
      amountUsed: 'Montant utilisé',
      stayToUse: 'Montant restant',
      ht: 'Montant HT',
      tva: 'Montant TVA',
      ttc: 'Montant TTC',
      paymentMethod: 'Mode de règlement',
      account: 'Compte bancaire',
      currency: 'Devise',
      charges: 'Charges',
      status: 'Statut'
    },
    filters: {
      type: 'Type',
      reference: 'Référence',
      provider: 'Fournisseur(s)',
      date: 'Date',
      created: 'Date de création',
      charges: 'Charge(s)',
      status: 'Statut'
    }
  }
}

export default {
  charges: chargesLang
}
